import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs/internal/Observable";
import { environment } from "../../../environments/environment";
import { DeleteUsers } from "../models/users/users/deleteUsers";
import { GetUserDto } from "../models/users/users/getUserDto";
import { UsersList } from "../models/users/users/usersList";
import { GenericResponseDto } from "../models/generic-response.dto";
import { UpdateUserProfileActive } from "../models/common/updateUserProfileActive.model";
import { payloadHeader } from "./shared.service";

@Injectable({
  providedIn: "root",
})
export class UsersListingService {
  private userManagementBaseURL = environment.baseUrl + "/User";

  constructor(private _http: HttpClient) {}

  getUsers(): Observable<GenericResponseDto<UsersList[]>> {
    return this._http.get<GenericResponseDto<UsersList[]>>(
      this.userManagementBaseURL + "/GetAllUsers"
    );
  }

  GetAllConfiguredUser(): Observable<GenericResponseDto<UsersList[]>> {
    return this._http.get<GenericResponseDto<UsersList[]>>(
      this.userManagementBaseURL + "/GetAllConfiguredUser"
    );
  }

  UpdateUserProfileActive(
    payload: UpdateUserProfileActive
  ): Observable<GenericResponseDto<{ id: number; IsProfileActive: boolean }>> {
    return this._http.put<
      GenericResponseDto<{ id: number; IsProfileActive: boolean }>
    >(`${this.userManagementBaseURL}/UpdateUserProfileActive`, payload, {
      headers: payloadHeader(payload).headers,
    });
  }

  deleteUsers(payload: DeleteUsers): Observable<GetUserDto[]> {
    return this._http.delete<GetUserDto[]>(
      this.userManagementBaseURL + "/DeleteUsers",
      payloadHeader<DeleteUsers>(payload)
    );
  }
}
